import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Football"
});
const _hoisted_1 = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M512 960a448 448 0 110-896 448 448 0 010 896zm0-64a384 384 0 100-768 384 384 0 000 768z"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M186.816 268.288c16-16.384 31.616-31.744 46.976-46.08 17.472 30.656 39.808 58.112 65.984 81.28l-32.512 56.448a385.984 385.984 0 01-80.448-91.648zm653.696-5.312a385.92 385.92 0 01-83.776 96.96l-32.512-56.384a322.923 322.923 0 0068.48-85.76c15.552 14.08 31.488 29.12 47.808 45.184zM465.984 445.248l11.136-63.104a323.584 323.584 0 0069.76 0l11.136 63.104a387.968 387.968 0 01-92.032 0zm-62.72-12.8A381.824 381.824 0 01320 396.544l32-55.424a319.885 319.885 0 0062.464 27.712l-11.2 63.488zm300.8-35.84a381.824 381.824 0 01-83.328 35.84l-11.2-63.552A319.885 319.885 0 00672 341.184l32 55.424zm-520.768 364.8a385.92 385.92 0 0183.968-97.28l32.512 56.32c-26.88 23.936-49.856 52.352-67.52 84.032-16-13.44-32.32-27.712-48.96-43.072zm657.536.128a1442.759 1442.759 0 01-49.024 43.072 321.408 321.408 0 00-67.584-84.16l32.512-56.32c33.216 27.456 61.696 60.352 84.096 97.408zM465.92 578.752a387.968 387.968 0 0192.032 0l-11.136 63.104a323.584 323.584 0 00-69.76 0l-11.136-63.104zm-62.72 12.8l11.2 63.552a319.885 319.885 0 00-62.464 27.712L320 627.392a381.824 381.824 0 0183.264-35.84zm300.8 35.84l-32 55.424a318.272 318.272 0 00-62.528-27.712l11.2-63.488c29.44 8.64 57.28 20.736 83.264 35.776z"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var football = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { football as default };
